const ViewWorkflowBiologicalInformation = () => {
  return <div>ViewWorkflowBiologicalInformation</div>;
};

export default ViewWorkflowBiologicalInformation;
